/* eslint @typescript-eslint/no-var-requires: "off" */
import 'open-sankey/src/css/bootstrap.css'
import 'open-sankey/src/css/main.css'
import 'open-sankey/src/css/colors/red.css'
import './css/Register.css'
import './css/Login.css'
import './css/react-quill.css'
import React, { Dispatch, FunctionComponent, SetStateAction, useRef, useState } from 'react'
import { render } from 'react-dom'

import SankeyApp from './SankeyApp'
import { convert_data } from 'open-sankey/dist/configmenus/SankeyConvert'
import { plus_convert_data } from 'sankeyanimation/dist/src/SankeyPlusConvert'
import { DefaultSankeyData } from './import/OpenSankey'
import { DefaultSankeyPlusStyleLink } from 'sankeyanimation/dist/src/SankeyPlusUtils'
import LZString from 'lz-string'
import './traduction'
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import { SuiteSankeyData, suiteApplicationContextType, suiteContextMenuType, suiteElementsSelectedType } from './import/Types'
import {app_name_opensankeyplus, app_name_sankeysuite} from './components/Register/LicenseFunctions'
import {dev_convert_data} from 'sankeydev/dist/src/SankeyDevConvert'
import i18next from './traduction'
import { DefaultSankeyDataFuncType } from 'open-sankey/src/configmenus/types/SankeyUtilsTypes'
import { SankeyData, SankeyLink, SankeyNode } from 'open-sankey/src/types/Types'
import { ConvertDataFuncType } from 'open-sankey/src/configmenus/types/SankeyConvertTypes'
import Register from './components/Register/Register'
import Login from './components/Login/Login'
import Account from './components/UserPages/Account'
import Dashboard from './components/UserPages/Dashboard'
import { blockers_suite_sankey } from './import/SankeyDev'
import { useTranslation } from 'react-i18next'
import { DictSetterInputValueType, SankeyPlusData, SankeyPlusLabel } from 'sankeyanimation/types/Types'
import { SankeyDevData } from 'sankeydev/types/Types'
import { AFMSankeyData } from 'afmsankey/types/Types'

// Accounts token
let token=false
let has_sankey_suite=false
let has_open_sankey_plus=false
let has_sankeydev=false

declare const window: Window &
  typeof globalThis & {
    SankeyToolsStatic: boolean
    sankey: {
      filiere?: string,
      header?: string,
      has_header?: boolean,
      footer?: boolean,
      logo_width?: number,
      excel?: string,
      publish?: boolean
      logo?: string
    }
  }

let exemple_menu={}
let formations_menu={}

// Search for licence logo
let logo_OS = ''
try {
  /* eslint-disable */
  // @ts-ignore
  logo_OS = require('./css/Open_Sankey_logo.jpg')
  /* eslint-enable */
  const path = window.location.href
  if ( !path.includes('localhost') ) {
    logo_OS = logo_OS.replace('static/', 'static/sankeysuite/')
  }
} catch (expt) {
  console.log('logo_OS not found')
}

let logo_OSP = ''
try {
  /* eslint-disable */
  // @ts-ignore
  logo_OSP = require('./css/OSP.png')
  /* eslint-enable */
  const path = window.location.href
  if ( !path.includes('localhost') ) {
    logo_OSP = logo_OSP.replace('static/', 'static/sankeysuite/')
  }
} catch (expt) {
  console.log('logo_OSP not found')
}

let logo_OSS = ''
try {
  /* eslint-disable */
  // @ts-ignore
  logo_OSS = require('./css/OSS.png')
  /* eslint-enable */
  const path = window.location.href
  if ( !path.includes('localhost') ) {
    logo_OSS = logo_OSS.replace('static/', 'static/sankeysuite/')
  }
} catch (expt) {
  console.log('logo_OSS not found')
}

let logo = window.sankey && window.sankey.logo?window.sankey.logo:''
if(!window.SankeyToolsStatic){
  try {
    logo = require('./css/opensankey.png')
    const path = window.location.href
    if ( !path.includes('localhost')) {
      logo = logo.replace('static/', 'static/sankeysuite/')
    }
  } catch (expt) {
    console.log('opensankey.png not found')
  }
}

let logo_terriflux = 'logo_terriflux.png'
if(!window.SankeyToolsStatic){
  try {
    logo_terriflux = require('./css/terriflux.png')
    const path = window.location.href
    if ( !path.includes('localhost') ) {
      logo_terriflux = logo_terriflux.replace('static/', 'static/sankeysuite/')
    }
  } catch (expt) {
    console.log('terriflux.png not found')
  }
}

// Login token
const set_token=(t:boolean)=>{
  token=t
  renderPage()
}

// AFM Sankey token
const set_sankey_suite=(t:boolean)=>{
  has_open_sankey_plus=t
  has_sankey_suite=t
  renderPage()
}

// OpenSankey+ token
const set_open_sankey_plus=(t:boolean)=>{
  has_open_sankey_plus=t
  renderPage()
}

// SankeyDev token
const set_sankeydev=(t:boolean)=>{
  has_sankeydev=t
  renderPage()
}

// LogOut
const unsetTokens=()=>{
  token=false
  has_sankey_suite=false
  has_open_sankey_plus=false
  has_sankeydev=false
  renderPage()
}

type SuiteRootCommponentTypes={
  exemple_menu        : object
  formations_menu      : object

}
const SuiteRootCommponent: FunctionComponent<SuiteRootCommponentTypes> = (
  {exemple_menu,formations_menu}) => {

  const username=token ? LZString.decompress(sessionStorage.getItem('username')) as string : ''
  const init_data = suite_default_sankey_data()

  if(!window.SankeyToolsStatic){
    // If the app is in edition mode then go search the data in localStorage
    const json_data = LZString.decompress(localStorage.getItem('data') as string) as string
    if (json_data !== null && json_data !== 'undefined' && json_data !== '') {
      const new_data = JSON.parse(json_data)
      Object.assign(init_data, new_data)
      suite_converter(init_data,suite_default_sankey_data)
    }

    // If we are use the app as creation tool then some token depend of the user
    // -------------Token for module of OpenSankey----------------------
    // Search for saved token in localStorage added after login
    const storage_token_plus=LZString.decompress(
    sessionStorage.getItem(app_name_opensankeyplus) as string) as string
    if(storage_token_plus!==null && storage_token_plus!==''){
      const d_t=JSON.parse(storage_token_plus)
      has_open_sankey_plus=d_t
    }

    const storage_token_suite=LZString.decompress(
    sessionStorage.getItem(app_name_sankeysuite) as string) as string
    if(storage_token_suite!==null && storage_token_suite!==''){
      const d_t=JSON.parse(storage_token_suite)
      if (d_t === true) {
        has_open_sankey_plus = d_t
      }
      has_sankey_suite=d_t
    }

    const storage_token_dev=LZString.decompress(sessionStorage.getItem('SankeyDev') as string) as string
    if(storage_token_dev!==null && storage_token_dev!==''){
      const d_t=JSON.parse(storage_token_dev)
      has_sankeydev=d_t
    }
  }else{
    // Else if the app is in visualisation mode then go search the data in the gloabel variable window.sankey
    // if (window.sankey.filiere) {
    //   localStorage.setItem('data', LZString.compress(JSON.stringify(window.sankey.filiere)))
    // }

    // const json_data = LZString.decompress(localStorage.getItem('data') as string) as string
    // if (json_data !== null && json_data !== 'undefined' && json_data !== '') {
    //   const new_data = JSON.parse(json_data)
    //   Object.assign(init_data, new_data)
    //   suite_converter(init_data,suite_default_sankey_data)
    // }
    Object.assign(init_data, window.sankey.filiere)

    // If we are use the app as viusalisation then token are automatically true (but some fonctionality are disabled)
    has_open_sankey_plus=true
    has_sankey_suite=true
    has_sankeydev=true
  }

  // ==================
  //  CREATION VARIABLE
  // ==================
  // ----------HOOK---------------
  const [data, pre_set_data] = useState<SuiteSankeyData>(init_data) // useState OK
  const [master_data, set_master_data2] = useState<SuiteSankeyData>() // useState OK
  const [view, set_postview] = useState(data.current_view) // useState OK
  //- login info
  const [name_user,set_name_user] = useState(username) // useState OK
  // For SankeyDev
  const [blocker_token_OSP,set_blocker_token_OSP]=useState(false) // useState OK
  const [blocker_token_SSM,set_blocker_token_SSM]=useState(false) // useState OK

  const blockers=has_sankeydev?blockers_suite_sankey(
    blocker_token_OSP,set_blocker_token_OSP,blocker_token_SSM,set_blocker_token_SSM):{}
  const token_sankey_suite = has_sankey_suite && !blocker_token_SSM


  let logo_application=logo
  // Create token that can be disbale b some variable used in submodule sankeydev
  const token_open_sankey_plus = has_open_sankey_plus && !blocker_token_OSP
  const storage_token=LZString.decompress(sessionStorage.getItem('token') as string) as string
  if(storage_token!==null && storage_token!==''){
    const d_t=JSON.parse(storage_token)
    token=d_t
  }
  if(!window.SankeyToolsStatic){
    if(has_open_sankey_plus){
      logo_application=logo_OSP
    }
    if(has_sankey_suite){
      logo_application=logo_OSS
    }
  }


  // ================================
  //  CREATION DICT OF VARIABLE USED
  // ================================
  /***********************************************************************************************/
  const applicationContext : suiteApplicationContextType = {
    t : useTranslation().t,
    logo_OS,logo_OSP,logo_OSS,
    logo_width : 100,
    app_name : 'SankeySuite',
    url_prefix : '/sankeytools/',
    logo:logo_application,
    logo_terriflux,
    token,
    has_sankey_suite,
    has_open_sankey_plus,
    has_sankeydev,
    unsetTokens,
    name_user
  }
  /***********************************************************************************************/
  const dict_variable_elements_selected : suiteElementsSelectedType = {
    ref_setter_mode_selection : useRef<Dispatch<SetStateAction<string>>>(()=>null),
    ref_getter_mode_selection : useRef<string>(),
    multi_selected_nodes : useRef([]),
    multi_selected_links : useRef([]),
    multi_selected_label : useRef([]),
    ref_selected_style_node : useRef('default'),
    ref_selected_style_link :  useRef('default'),
    first_selected_node : useRef<SankeyNode>(),
    ref_pre_idSource : useRef('none'),
    ref_pre_idTarget : useRef('none'),
    ref_display_link_opacity : useRef<Dispatch<SetStateAction<string>>[]>([]),
    displayedInputLinkValueSetterRef : useRef<Dispatch<SetStateAction<string>>[]>([]),
    displayedInputLinkValueRef : useRef<string>(''),
    userScaleRef : useRef(data.user_scale)
  }
  /***********************************************************************************************/
  const d_setter_input_value:DictSetterInputValueType={
    r_setter_editor_content_fo_zdt:useRef<Dispatch<SetStateAction<string>>[]>([]),
    r_setter_editor_content_fo_node:useRef<Dispatch<SetStateAction<string>>>(),
    r_setter_value_editor_name_view:useRef<Dispatch<SetStateAction<string>>>(),
  }
  /***********************************************************************************************/
  const contextMenu : suiteContextMenuType = {
    ref_setter_contextualised_node : useRef<Dispatch<SetStateAction<SankeyNode|undefined>>>(),
    ref_contextualised_node : useRef<SankeyNode|undefined>(),
    ref_setter_contextualised_link : useRef<Dispatch<SetStateAction<SankeyLink|undefined>>>(),
    tagContext : useRef<[string|undefined, Dispatch<SetStateAction<string|undefined>>][]>([]),
    closeAllMenuContext : ()=>{
      contextMenu.ref_setter_contextualised_node.current!(undefined)
      contextMenu.ref_setter_contextualised_link.current!(undefined)
      contextMenu.tagContext.current![0][1](undefined)
      contextMenu.showContextZDDRef.current![1](false)
      contextMenu.contextualised_zdt.current!(undefined)
    },
    pointer_pos : useRef([window.innerWidth/4,window.innerHeight/4]),
    showContextZDDRef : useRef<[boolean, Dispatch<SetStateAction<boolean>>]>(),
    contextualised_zdt : useRef<Dispatch<SetStateAction<SankeyPlusLabel|undefined>>>()
  }
  /*************************************************************************************************/


  const set_data=(ndata:SankeyData)=>{
    dict_variable_elements_selected.userScaleRef.current = ndata.user_scale
    if(d_setter_input_value.r_setter_editor_content_fo_node.current && dict_variable_elements_selected.multi_selected_nodes.current.length>0){
      d_setter_input_value.r_setter_editor_content_fo_node.current(dict_variable_elements_selected.multi_selected_nodes.current[0].FO_content)
    }
    if(d_setter_input_value.r_setter_editor_content_fo_zdt.current && dict_variable_elements_selected.multi_selected_label.current.length>0){
      d_setter_input_value.r_setter_editor_content_fo_zdt.current.forEach(f=>f(dict_variable_elements_selected.multi_selected_label.current[0].content))
    }
    if(data.maximum_flux && data.minimum_flux && data.minimum_flux>data.maximum_flux){
      data.maximum_flux=data.minimum_flux
      // maximum_flux.current  = data.minimum_flux
    }
    pre_set_data({...ndata as SuiteSankeyData})
  }

  const set_master_data= (s:SankeyPlusData| SankeyDevData |undefined) => {
    // if(d_setter_input_value.r_setter_value_editor_name_view.current){
    //   if (s && s.current_view && s.current_view!=='none' &&s.view.length>0) {

    //     const v = s.view.filter(v=>v.id===s.current_view)
    //     if (v.length>0) {
    //     d_setter_input_value.r_setter_value_editor_name_view.current!(v[0].nom)
    //     } else {
    //     d_setter_input_value.r_setter_value_editor_name_view.current!('')
    //     }
    //   } else {
    //   d_setter_input_value.r_setter_value_editor_name_view.current!('')
    //   }
    // }
    set_master_data2(s as SuiteSankeyData)
  }

  const set_view=(s:string)=>{
    data.current_view=s
    if(master_data){
      master_data.current_view=s
    }
    set_postview(s)
  }

  // Réinitialise data et vide les noeud/liens sélectionnés
  const Reinitialization = () => {
    if(!window.SankeyToolsStatic){
      const new_data = suite_default_sankey_data()
      dict_variable_elements_selected.multi_selected_nodes.current = []
      dict_variable_elements_selected.multi_selected_links.current = []
      dict_variable_elements_selected.multi_selected_label.current = []
      localStorage.removeItem('diff')
      localStorage.removeItem('data')
      localStorage.removeItem('last_save')
      localStorage.removeItem('initial_data')
      localStorage.removeItem('icon_imported')
      dict_variable_elements_selected.ref_selected_style_node.current = 'default'
      dict_variable_elements_selected.ref_selected_style_link.current = 'default'
    contextMenu.ref_setter_contextualised_node.current!(undefined)
    contextMenu.ref_setter_contextualised_link.current!(undefined)
    contextMenu.tagContext.current![0][1](undefined)
    contextMenu.showContextZDDRef.current![1](false)
    set_data(new_data)
    set_master_data(undefined)
    set_view(new_data.current_view)
    sessionStorage.setItem('dismiss_warning_sankey_plus','0')
    sessionStorage.setItem('dismiss_warning_sankey_mfa','0')
    }else{
    // do nothing
    }

  }

  const Application=<SankeyApp
    data={data}
    set_data={set_data}
    master_data={master_data}
    set_master_data={set_master_data}
    view={view}
    set_view={set_view}
    Reinitialization={Reinitialization}
    exemple_menu={exemple_menu}
    formations_menu={formations_menu}
    token={token}
    has_sankey_suite={token_sankey_suite}
    has_open_sankey_plus={token_open_sankey_plus}
    has_sankeydev={has_sankeydev}
    get_default_data={suite_default_sankey_data}
    suite_convert_data={suite_converter}
    applicationContext={applicationContext}
    dict_variable_elements_selected={dict_variable_elements_selected}
    contextMenu={contextMenu}
    d_setter_input_value={d_setter_input_value}
  />
  if(window.SankeyToolsStatic){
    return Application
  }else{
    return <BrowserRouter>
      <Routes>
        <Route path='/register' element={
          <Register
            navbar_logo={logo_application}
            navbar_logo_width={100}
            navbar_app_version='Version 1.0.0'
            setToken={set_token}
            useNavigate={useNavigate}
            data={data}
            set_data={set_data as (_:SankeyData)=>void}
          />}
        />
        <Route path='/login' element={
          <Login
            navbar_logo={logo_application}
            navbar_logo_width={100}
            navbar_app_version='Version 1.0.0'
            setToken={set_token}
            setOpenSankeyPlus={set_open_sankey_plus}
            setSankeySuite={set_sankey_suite}
            setSankeyDev={set_sankeydev}
            useNavigate={useNavigate}
            data={data}
            set_data={set_data as (_:SankeyData)=>void}
            set_name_user={set_name_user}
          />}
        />
        <Route path='/dashboard' element={
          <Dashboard
            navbar_logo={logo_application}
            navbar_logo_width={100}
            navbar_app_version='Version 1.0.0'
            token={token}
            exemple_menu={exemple_menu}
            data={data}
            set_data={set_data as (_:SankeyData)=>void}
            unsetTokens={unsetTokens}
            useNavigate={useNavigate}
            suite_convert_data={suite_converter}
            SuiteDefaultData={suite_default_sankey_data}
          />}
        />
        <Route path='/account' element={
          <Account
            navbar_logo={logo_application}
            navbar_logo_width={100}
            navbar_app_version='Version 1.0.0'
            token={token}
            setOpenSankeyPlus={set_open_sankey_plus}
            setSankeySuite={set_sankey_suite}
            setSankeyDev={set_sankeydev}
            unsetTokens={unsetTokens}
            useNavigate={useNavigate}
            data={data}
            set_data={set_data as (_:SankeyData)=>void}
            blocker_suite_sankey={blockers}
          />}
        />
        <Route path='/' element={Application}/>
        <Route path="*" element={<Navigate to="/" />}/>
      </Routes>
    </BrowserRouter>
  }
}

const suite_default_sankey_data:()=>SuiteSankeyData = () => {
  const type_to_return={...DefaultSankeyData()}
  if(has_sankey_suite){

    const AFM_var={show_uncert: false,

      trade_sectors : [],
      trade_close_hspace: 50,
      trade_close_vspace: 20,
      trade_hspace: 200,

      trade_left_shift: 0.04999,
      trade_right_shift: 0.95,
      trade_max_shift: 0.2,

      units_names : [[]],
      tooltip_names : []}
    Object.assign(type_to_return,AFM_var)
  }

  const OSP_var={
    is_catalog:false,
    view:[],
    current_view:'none',
    labels:{},
    icon_catalog:{},
    style_link:{'default':DefaultSankeyPlusStyleLink()},
    unitary_node:[],
    unit_link_value_display:'percent',
    background_image:''
  }
  Object.assign(type_to_return,OSP_var)

  if(has_sankeydev){
    const Dev_var={
      unitary_node:[],
      process_transfo_ref:{},
      unit_link_value_display:'percent'
    }
    Object.assign(type_to_return,Dev_var)
  }

  return type_to_return as SuiteSankeyData
}
const suite_converter:ConvertDataFuncType=(data:SankeyData,DefaultData:DefaultSankeyDataFuncType)=>{
  plus_convert_data(data,DefaultData)
  dev_convert_data(data)
  convert_data(data,DefaultData)
  const special_data_cast=(data as AFMSankeyData)
  if(special_data_cast.free_null_link_visible===undefined){
    special_data_cast.free_null_link_visible=true
  }
}


const renderPage=()=>{
  render(<SuiteRootCommponent exemple_menu={exemple_menu} formations_menu={formations_menu}/>,document.getElementById('react-container'))
}
window.React = React
i18next.changeLanguage(navigator.language.includes('fr')?'fr':'en')



window.SankeyToolsStatic = window.SankeyToolsStatic === undefined ? false : window.SankeyToolsStatic

if (!window.SankeyToolsStatic) {
  // If the app is in mode edition then we fetch exemples in the server then we render the app
  if (!window.sankey) {
    window.sankey = {}
  }
  const fetchData = {
    method: 'POST'
  }

  const path = window.location.origin
  const url = path + '/opensankey/sankey/menu_examples'
  fetch(url, fetchData).then(response => {
    response.text().then(text => {
      const json_data = JSON.parse(text)
      exemple_menu = json_data.exemples_menu
      if(Object.keys(json_data.exemples_menu['Formations']).length>0){
        //formations_menu = {...json_data.exemples_menu['Formations']['Tutoriels']}
        // Filter out artefacts sub-object that appear when the app deployed on site
        formations_menu=Object.fromEntries(Object.entries(json_data.exemples_menu['Formations']['Tutoriels']).filter(d=>d[0]!=='artefacts'))

        // Filter out advanced opensankey examples if we don't have a OS+ licence
        if(!has_open_sankey_plus && '1_OpenSankeyAvancée' in formations_menu){
          formations_menu=Object.fromEntries(Object.entries(formations_menu).filter(d=>d[0]!=='1_OpenSankeyAvancée'))
        }
        // Filter out expert examples if we don't have a SankeySuite licence
        if(has_sankey_suite){
          formations_menu=Object.fromEntries(Object.entries(formations_menu).filter(d=>!['2_Structure','3_Arborescence_Hierarchies','4_Données_Contraintes_Reconciliation','5_Fiabilités','7_Scenarisation','8_Scenarisation_Gisements','9_Forêt_Bois','10_FluxDePorc','FichiersRéférences'].includes(d[0])))
        }
        delete json_data.exemples_menu['Formations']['Tutoriels']
      }

    }).catch(() => {
      exemple_menu={}
      formations_menu={}
    }).then(()=>{
      renderPage()
    })
  })

} else {
  // Else if the app is in mode visualisation then we directly render the app
  renderPage()
}
